<template>
  <el-row :getter="20">
    <el-col :span="6">
      <el-tree
        :data="govTree"
        :props="govTreeProps"
      ></el-tree>
    </el-col>
    <el-col :span="18">
      <div class="tabel-bar">
        <div class="tabel-bar-left">
          <el-button
            type="primary"
            size="medium"
            @click="govAddFormVisible = true"
            >新增用户</el-button
          >
          <el-button size="medium">批量删除</el-button>
          <el-button size="medium">分配角色</el-button>
        </div>
        <div class="tabel-bar-right">
          <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            size="medium"
          ></el-input>
          <el-tooltip effect="dark" content="刷新列表" placement="bottom">
            <span class="el-icon-refresh icon-hover refresh-btn"></span>
          </el-tooltip>
          <el-tooltip effect="dark" content="筛选列表" placement="bottom">
            <el-popover
              placement="bottom-end"
              width="120"
              trigger="click"
            >
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="用户编号"></el-checkbox>
                <el-checkbox label="用户名"></el-checkbox>
                <el-checkbox label="姓名"></el-checkbox>
                <el-checkbox label="状态"></el-checkbox>
                <el-checkbox label="角色"></el-checkbox>
                <el-checkbox label="所属组织机构"></el-checkbox>
              </el-checkbox-group>
                <i
                  slot="reference"
                  class="d-block iconfont icon-liebiao is-rotate"
                ></i>
            </el-popover>
          </el-tooltip>
        </div>
      </div>
      <el-table :data="userData">
        <el-table-column
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          property="jigou"
          label="所属机构"
        ></el-table-column>
        <el-table-column
          property="loginName"
          label="登录名"
        ></el-table-column>
        <el-table-column
          property="name"
          label="姓名"
        ></el-table-column>
        <el-table-column
          property="static"
          label="状态"
        ></el-table-column>
        <el-table-column
          property="role"
          label="角色"
          :filters="[{ text: '管理', value: '管理' }, { text: '操作', value: '操作' }]"
          :filter-method="filterTag"
        ></el-table-column>
        <el-table-column
          property="regTime"
          label="注册时间"
        ></el-table-column>
        <el-table-column
          property="caozuo"
          width="160"
          label="操作"
        >
          <el-button type="text">编辑</el-button>
          <el-button type="text">删除</el-button>
          <el-button type="text">分配角色</el-button>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        align="right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="100"
        :total="total"
      >
      </el-pagination>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      checkList: [],
      searchText: '',
      currentPage: 1,
      total: 400,
      govTreeProps: {
        children: 'children',
        label: 'label'
      },
      govTree: [
        {
          label: '沂水县农机局',
          children: [
            {
              label: '镇级别',
              children: [
                {
                  label: '村级别'
                }
              ]
            }
          ]
        },
        {
          label: '沂水县农机局2',
          children: [
            {
              label: '镇级别2-1',
              children: [
                {
                  label: '村级别2-1-1'
                }
              ]
            },
            {
              label: '镇级别22-2',
              children: [
                {
                  label: '村级别2-2-1'
                }
              ]
            }
          ]
        },
        {
          label: '沂水县农机局 3',
          children: [
            {
              label: '二级 3-1',
              children: [
                {
                  label: '三级 3-1-1'
                }
              ]
            },
            {
              label: '二级 3-2',
              children: [
                {
                  label: '三级 3-2-1'
                }
              ]
            }
          ]
        }
      ],
      userData: [
        {
          id: 1,
          jigou: 'w00001',
          loginName: '100001',
          name: '张三',
          static: 1,
          role: '管理',
          regTime: '2020-07-03 12:00:00'
        },
        {
          id: 2,
          jigou: 'w00002',
          loginName: '100002',
          name: '张三',
          static: 1,
          role: '管理',
          regTime: '2020-07-03 12:00:00'
        },
        {
          id: 3,
          jigou: 'w00003',
          loginName: '100003',
          name: '张三',
          static: 1,
          role: '管理',
          regTime: '2020-07-03 12:00:00'
        }
      ]
    }
  },
  watch: {
    checkList(val) {
      console.log(val)
    }
  },
  methods: {
    filterTag(value, row) {
      return row.role === value
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
    }
  }
}
</script>
